(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Modello', Modello);

    Modello.$inject = ['$resource', 'DateUtils'];

    function Modello ($resource, DateUtils) {
        var resourceUrl =  'api/modellos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
